module.exports = "<div id=\"zipField\" class=\"inputField confidential postalCode\" floating-label content>\n    <input type=\"text\" name=\"postalCode\" id=\"postalCode\" ng-model=\"zipCode\"\n       autocapitalize=\"off\" aria-required=\"true\" autocomplete=\"off\" ng-change=\"changeZip(zipCode)\" xo-validation='{\"validator\": \"validZip\"}'\n       minlength=\"{{minLength}}\" maxlength=\"{{maxLength}}\" ng-blur=\"doneFunction()\"\n       data-error-text=\"{{zipErrorText}}\" xo-error-tooltip ng-required=\"{{zipRequired}}\"/>\n    <label for=\"postalCode\" id=\"postalCodeLabel\" >{{zipLabel}}</label>\n</div>\n\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-form-components/src/zipcode/template.html
 ** module id = 291
 ** module chunks = 1
 **/